/**
 * Auth Logout Controller
 *
 * POST /auth/logout to invalidate the nm_session cookie server-side,
 * then redirect to /connexion.html. Redirects on failure too — the user wants
 * to be signed out either way, and the cookie may already be invalid.
 */

import BaseController from "./base_controller.js";
import { api } from "../services/api.js";
import { clearCache as clearFavoritesCache } from "../services/favorites/cache.js";

export default class AuthLogoutController extends BaseController {
  static targets = ["status"];

  async connect() {
    try {
      await api.logout();
    } catch (_err) {
      // Swallow — we redirect to /connexion.html either way. The backend's
      // logout endpoint also wipes the cookie via Set-Cookie expiring,
      // and the user has clearly asked to sign out.
    }
    clearFavoritesCache();
    window.location.replace("/connexion.html");
  }
}
